import React from 'react';
import TextBlock from './TextBlock';
import SubHeaderBlock from './SubHeaderBlock';
import ListBlock from './ListBlock';
import CardGridBlock from './CardGridBlock';
import GifGridBlock from './GifGridBlock';
import DirectionsBlock from './DirectionsBlock';
import ImageBlock from './ImageBlock';
import VideoBlock from './VideoBlock';
import SideBySideBlock from './SideBySideBlock';

const BlockRenderer = ({ block }) => {
  if (!block || !block.type) return null;

  switch (block.type) {
    case 'text':
      return <TextBlock block={block} />;
    
    case 'sub-header':
      return <SubHeaderBlock block={block} />;
    
    case 'list':
      return <ListBlock block={block} />;
    
    case 'card-grid':
      return <CardGridBlock block={block} />;
    
    case 'gif-grid':
      return <GifGridBlock block={block} />;
    
    case 'directions':
      return <DirectionsBlock block={block} />;
    
    case 'image':
      return <ImageBlock block={block} />;
    
    case 'video':
      return <VideoBlock block={block} />;
    
    case 'side-by-side':
      return <SideBySideBlock block={block} />;
    
    default:
      console.warn(`Unknown block type: ${block.type}`);
      return null;
  }
};

export default BlockRenderer;

